import {
  MaskType,
  getMaskingStrategy,
  formatWithCursorTracking,
} from "@/composables/maskingUtils";
import { Option } from "@/models/form";

export enum FormModes {
	view = "view",
	add = "add",
	edit = "edit",
}

export type ValidApplicantFormModes = Extract<keyof typeof FormModes, "view" | "edit">;

export interface FormOption {
  checked: boolean;
  id: number | string;
  name: string;
  label?: string;
  showOnAdd?: boolean;
  showOnEdit?: boolean;
}

export interface FormField {
  name: string;
  label: string;
  type: "date" | "text" | "money" | "number" | "select" | "document-status";
  value?: any;
  width?: string;
  options?: FormOption[] | Option[] | null;
  showOnAdd: boolean;
  showOnEdit: boolean;
  showOnView?: boolean;
  disabledOnEdit: boolean;
	disabledOnAdd?: boolean;
  maskType?: MaskType;
  readonly?: boolean;
	required?: boolean;
  errors?: string[] | null;
	hideErrorMessage?: boolean;
  hideLabel?: boolean;
  title?: string | null;
  schema?: any;
  tooltip?: boolean;
  tooltipText?: string;
  subfield?: FormField;
  fieldSchema?: any;
  placeholder?: string;
  rules?: any;
  modelValue?: any;
	category?: string;
	maxWidth?: number;
	initialValue?: any;
	validationSchema?: any;
}
